import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

export const GeolocationExtras = z
  .object({
    metrics: z.array(z.string()).optional(),
    startDate: z.string(),
    endDate: z.string(),
    dateRangeType: z.string().nullish(),
    filters: z.array(FilterDefinitionForExtras),
  })
  .describe('GeolocationExtras');

export type GeolocationExtras = z.infer<typeof GeolocationExtras>;

export const GeolocationInputs = z.object({
  dropdowns: EmptyObject,
  extras: GeolocationExtras,
});

export const GeolocationRequest = createCustomVizRequestSchema(
  'geolocation',
  GeolocationInputs,
);

export type GeolocationRequest = z.infer<typeof GeolocationRequest>;

export const GeolocationMarker = z.object({
  coordinates: z.string(),
  tooltipContent: z.string(),
});

export type GeolocationMarker = z.infer<typeof GeolocationMarker>;

export const GeolocationOutput = z
  .object({
    metrics: z.array(z.string()),
    markers: z.array(GeolocationMarker),
  })
  .describe('GeolocationOutput');

export type GeolocationOutput = z.infer<typeof GeolocationOutput>;

export const GoogleMapInnerProps = z.object({
  markers: z.array(GeolocationMarker),
});

export type GoogleMapInnerProps = z.infer<typeof GoogleMapInnerProps>;
